import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=05876eb0&scoped=true&"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=05876eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05876eb0",
  null
  
)

export default component.exports